const EnrichmentType = {
	Model: "Model",
	Video: "Video",
	Audio: "Audio",
	Link: "Link",
	Quiz: "Quiz"
}

export default EnrichmentType;